import { useState } from "react";
import { faqs } from "@/mocks/contest";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <span className="flex items-center gap-2 text-sm font-bold tracking-wide text-accent-600">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
            关于每日大赛，你想知道的都在这里
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于更新频率、内容来源、投稿与转载，这里集中解答大家的常见疑问。没找到答案？欢迎滑到底部订阅并给我们留言。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-2xl border border-background-200 bg-background-100 p-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-mail-send-line" />
            </span>
            <div>
              <p className="text-sm font-bold text-foreground-900">投稿 / 合作 / 反馈</p>
              <p className="text-sm text-foreground-600">hello@daily-race.cn</p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={open}
                >
                  <span className="text-sm font-bold text-foreground-900 md:text-base">{item.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition ${
                      open ? "bg-accent-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg`} />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}